import { RegisterMethod } from '@reach/interfaces/auth/auth.types';
import { Nullable } from '@reach/interfaces/typescript/nullable';
import { AdminFeatureFlags } from '@reach/interfaces/user/admin-feature-flags.enum';
import { CountryCode } from '@reach/interfaces/user/country.enum';
import { Gender } from '@reach/interfaces/user/gender.enum';
import { UserWithoutSensitive } from '@reach/interfaces/user/user.interface';
import { UserFeatureFlags } from '@reach/interfaces/user/user-feature-flags';
import { UserType } from '@reach/interfaces/user/user-type.enum';

export interface ClientUser {
	_raw: UserWithoutSensitive;
	id: string;
	username: string;
	type: UserType;
	activatedAt: number;
	impersonating: boolean;
	registerMethod: RegisterMethod;
	featureFlags: UserFeatureFlags[];
	adminLevel: AdminFeatureFlags;
	thumbnailUrl: Nullable<string>;
	imageUrl: Nullable<string>;
	email: string;
	emailVerified: boolean;
	fullName: Nullable<string>;
	firstName: Nullable<string>;
	country: Nullable<CountryCode>;
	gender: Nullable<Gender>;
	followingTeamLeader: boolean;
}
